import { useTranslation } from "react-i18next"
import type { TSession } from "@/types"

export function SessionTitle({ id, title, type }: Pick<TSession, "title" | "id" | "type">) {
  const { t } = useTranslation()

  if (type == "coffee") {
    return `${t("Session")} #${id}`
  }
  return title
}
